<template>
	<base-item-group :item="item" text sub-group />
</template>

<script>
import BaseItemGroup from '@/components/base/ItemGroup';

export default {
	name: 'ItemSubGroup',
	components: {
		BaseItemGroup,
	},
	props: {
		item: {
			type: Object,
			default: () => ({
				avatar: undefined,
				group: undefined,
				title: undefined,
				children: [],
			}),
		},
	},
};
</script>
